import { useTranslation } from 'react-i18next';

import { type CardDetail, type ContentBlock, useUpdateBlock } from '@/entities/card';
import { EditableMarkdown } from '@/shared/ui/EditableMarkdown';

import { useCardAbilities, useEditingSignal } from './abilities';

const MAX_LENGTH = 50_000;

interface Props {
  card: CardDetail;
  block: ContentBlock;
  startEditing: boolean;
  onEditingDone: () => void;
}

/** Rendered Markdown (safe); a click edits it in place and leaving the editor saves it. */
export function MarkdownBlock({ card, block, startEditing, onEditingDone }: Props) {
  const { t } = useTranslation();
  const update = useUpdateBlock(card.id);
  const { editContent } = useCardAbilities();
  const signal = useEditingSignal();
  return (
    <EditableMarkdown
      value={block.markdown_text ?? ''}
      label={t('content.markdown')}
      emptyText={t('content.emptyText')}
      editLabel={t('content.edit')}
      maxLength={MAX_LENGTH}
      startEditing={startEditing && editContent}
      readOnly={!editContent}
      onEditingChange={(active) => {
        signal(`md-${block.id}`, active);
      }}
      onDone={onEditingDone}
      onSave={(next) => update.mutateAsync({ blockId: block.id, markdown_text: next })}
    />
  );
}
